import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { primaryKey } from 'app/infrastructure/data/wireformat';
import { CaseData } from 'app/types-shared';
import { endpoint } from '../endpoints';

export const api = {

  duplicateCase: async (caseIdToDuplicate: number, queryParameters: {[key:string]: string | number}) => {
    const remote = new RemoteData(endpoint.draft);
    const response: any = await remote.resource<CaseData>()
      .filter(queryParameters)
      .create({
        caseTypeId: 0,
        caseId: 0,
        caseIdToDuplicate
      }, false);

    const json = await response.json();

    return { draftId: primaryKey(json.data), messages: json.messages };
  }

};
